<template>
    <b-container fluid>
        <vue-toastr ref="toastr" />
        <div :class="{blur: loading}">
            <b-row>
                <b-col>
                    <b-card title="Мои счета">
                        <b-table :items="accounts" :fields="accountsFields"></b-table>
                    </b-card>
                </b-col>
            </b-row>
        </div>
        <div v-if="loading" class="loading-container">
            <data-loading></data-loading>
        </div>
    </b-container>
</template>

<script>
    import DataLoading from '@/containers/DataLoading.vue'
    import Toastr from 'vue-toastr'

    export default {
        name: 'finance-accounts',
        components: {
            'data-loading': DataLoading,
            'vue-toastr': Toastr
        },
        data () {
            return {
                accounts: [],
                accountsFields: {
                    id: {
                        label: '#',
                        tdClass: 'small'
                    },
                    currency: {
                        label: 'Валюта',
                        tdClass: 'small'
                    },
                    amount: {
                        label: 'Остаток'
                    }
                },
                loading: false
            }
        },
        mounted () {
            this.loadAccounts()
        },
        methods: {
            loadAccounts () {
                this.loading = true
                this.axios.get('finance/accounts')
                    .then(response => {
                        this.accounts = response.data['accounts']

                        if (response.data.hasOwnProperty('message') && response.data['message']) {
                            this.$refs['toastr'].i(response.data['message'])
                        }

                        setTimeout(() => {
                            this.loading = false
                        }, 500)
                    })
                    .catch(() => {
                        this.$refs['toastr'].e('Произошла ошибка')
                    })
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Accounts.vue?19abe31c